<template>
  <!-- ======= Footer ======= -->
  <footer id="footer">

  </footer><!-- End Footer -->
</template>

<script>
export default {
  name: 'Bawah',
}
</script>